// src/workspace/WorkspaceReferencePage.jsx
//
// PLACEHOLDER. Step 3.
//
// The key list is already generated from KEY_ACTIONS in
// components/wellfinder/adjudicationKeys.js — the same data the in-review `?`
// overlay reads, so the reference cannot describe a binding that does not
// exist. That is why this page is cheap to finish and is not being rushed now.
//
// What it still needs is the domain material from the training deck:
// what-am-I-looking-at, the tier definitions, and the first-session checklist.
// That is prose someone has to write, not code.
export default function WorkspaceReferencePage() {
  return (
    <div className="mx-auto w-full max-w-2xl px-6 py-16">
      <h1 className="text-xl font-medium tracking-tight">Reference</h1>
      <p className="mt-2 text-sm text-fg-secondary">
        Keys, what you are looking at, and the first-session checklist.
      </p>
      <p className="mt-8 text-xs text-fg-secondary">
        The key list is generated from the same source the in-review{" "}
        <kbd className="rounded border border-bg-border px-1">?</kbd> overlay
        uses. Domain material from the training deck arrives in a later step.
      </p>
    </div>
  );
}
